import React, { useState } from 'react';
import { Button, Menu, Text } from '@fragments';
import { IconPlus, IconAdjustmentsHorizontal } from '@tabler/icons-react';
import SocialAvatar from '../../../../components/SocialAvatar';
import { profileKey } from '../../../../hooks/useAccounts';
import { STUDIO_HOME } from '../../../../enums/routes';
import './styles.scss';

// As wide as its longest @ (Instagram allows 30 characters) beside the avatar and the check.
const MENU_CONFIG = { fitContent: true };
const MENU_PAPER = { minWidth: 240, maxWidth: 'min(400px, calc(100vw - 32px))' };

// The active profile, first in the bar. Hidden until the creator has connected one (the
// @ onboarding); then it opens the connected profiles (how many of `limits.max_profiles`),
// connecting another one (the same @ onboarding, on the home) and the profiles' settings.
// Compact (phone header): the avatar alone.
export default function ProfileSwitcher({ studio: s, compact = false }) {
  const { t, accounts } = s;
  const [open, setOpen] = useState(false);
  const { active } = accounts;
  if (!active) return null;
  const avatar = profile => <SocialAvatar picture={profile.picture} label={profile.handle} platform={profile.platform} />;
  const connect = () => { s.onboarding.startAdding(); s.navigate(STUDIO_HOME); };
  const max = s.features.multiple_profiles ? s.capabilities?.limits?.max_profiles ?? null : null;
  const full = s.features.multiple_profiles && !accounts.canAdd && max != null;
  const items = [
    ...accounts.list.map(profile => ({
      id: profileKey(profile),
      label: `@${profile.handle}`,
      icon: avatar(profile),
      active: profileKey(profile) === profileKey(active),
      onClick: () => accounts.select(profile),
    })),
    { divider: true },
    accounts.canAdd && { id: 'connect', label: t('profileConnect'), icon: <IconPlus />, onClick: connect },
    full && { id: 'limit', label: t('profileLimitReached', { max }), icon: <IconPlus />, disabled: true },
    { id: 'settings', label: t('profileSettings'), icon: <IconAdjustmentsHorizontal />, onClick: () => s.setModal('profile') },
  ];
  return <Menu items={items} onOpenChange={setOpen} config={MENU_CONFIG} paperSx={MENU_PAPER} header={<div className="studio-profile-menu__head">
    <Text.subheading contrast={6}>{t('profilesConnected')}</Text.subheading>
    {max != null && <Text.caption contrast={5}>{t('profilesCount', { current: accounts.list.length, max })}</Text.caption>}
  </div>}>
    {compact
      ? <Button className="studio-account" variant="rounded" color="overlay" icon={avatar(active)}
        aria-haspopup="menu" aria-expanded={open} aria-label={t('profileMenu', { handle: active.handle })} />
      : <Button className="studio-account" variant="rounded" color="overlay" dropdown startIcon={avatar(active)}
        aria-haspopup="menu" aria-expanded={open} aria-label={t('profileMenu', { handle: active.handle })}>
        {`@${active.handle}`}
      </Button>}
  </Menu>;
}
